module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.modalVisible === 'report-export-in-progress') ? _c('layout-general', {
    on: {
      "close": function($event) {
        return _vm.modalClose()
      }
    }
  }, [_c('h4', {
    staticClass: "modal-title",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v(_vm._s(_vm.$t('general.labels.exporting')) + "...")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', [_c('h4', {
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.$t('general.labels.your')) + "\n      "), _c('span', {
    staticClass: "important-info"
  }, [_vm._v(_vm._s(_vm.$t('modal.export_table_in_progress.processing_request')))]), _vm._v("\n       " + _vm._s(_vm.$t('modal.export_table_in_progress.send_email')) + "\n      "), _c('span', {
    staticClass: "important-info"
  }, [_vm._v(_vm._s(_vm.email))]), _vm._v(". " + _vm._s(_vm.$t('modal.export_table_in_progress.some_hours')))])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.modalClose()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('general.actions.close')))])])]) : _vm._e()
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-eebfbf1a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/ExportTableInProgress.vue
 ** module id = 922
 ** module chunks = 1
 **/